import { Box, Heading3, StackView, Text } from 'localmed-core';
import React, { useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { DiButton } from '../../../../../../../shared/components/DiComponents';
import { DiInsuranceIssuerSelectWithData } from '../../../../../../../shared/components/InsuranceIssuerSelect';
import BackLink from '../../../BackLink';
import { IStepProps } from '../../../schedulingWizard';
import { BackButton, ContentWrapper, Wrapper } from '../../../styles';

interface Props extends IStepProps {
  setIsOpen: (value: boolean) => void;
}

// Until i find a better way to handle type error
const DiInsuranceIssuerSelectWithDataAny: any = DiInsuranceIssuerSelectWithData;

export default function SchedulingInsuranceSelection({ wizard, setIsOpen }: Props) {
  const [issuer, setIssuer] = useState(wizard?.values.insuranceIssuer);

  useEffect(() => {
    if (wizard?.trackSchedulingEvent) {
      wizard.trackSchedulingEvent(
        'Scheduling Insurance Selection Screen',
        'SchedulingInsuranceSelection'
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!wizard) return null;
  const { provider } = wizard.values;

  const Save = () => {
    if (issuer !== wizard.values.insuranceIssuer) {
      wizard.form.change('insuranceIssuer', issuer);
    }
    setIsOpen(false);
  };

  return (
    <Wrapper>
      <BackLink
        onClick={() => {
          setIsOpen(false);
        }}
      />
      <ContentWrapper>
        <Box width="100%">
          <StackView spacing="md">
            <Heading3>
              <FormattedMessage
                id="scheduling.SchedulingInsuranceSelection.title"
                defaultMessage="Lets help you change that."
              />
            </Heading3>
            <Text tabIndex={0}>
              <FormattedMessage
                id="scheduling.SchedulingInsuranceSelection.insuranceSelectCaption"
                defaultMessage="What will your payment method be?"
              />
            </Text>
            <Box maxWidth="380px">
              <DiInsuranceIssuerSelectWithDataAny
                id="insuranceIssuer"
                emptyLabel="Other"
                providerId={provider && provider.id}
                selectedItem={issuer}
                initialSelectedValue={issuer && issuer.id}
                onChange={(selectedItem) => setIssuer(selectedItem)}
                onProviderInsuranceCoverageChange={(providerInsurance) =>
                  wizard.form.change('providerInsuranceCoverage', providerInsurance)
                }
              />
            </Box>
          </StackView>
        </Box>
      </ContentWrapper>
      <Box display="flex" justifyContent={{ _: 'center', lg: 'space-between' }} mx="md">
        <BackButton
          onClick={() => {
            setIsOpen(false);
          }}
          display={{ _: 'none', lg: 'inherit' }}
          variant="subtle"
          size="xl"
        >
          <FormattedMessage
            id="scheduling.SchedulingInsuranceSelection.cancelButton"
            defaultMessage="Cancel"
          />
        </BackButton>
        <DiButton onClick={Save} size="xl">
          <FormattedMessage
            id="scheduling.SchedulingInsuranceSelection.saveButton"
            defaultMessage="Save"
          />
        </DiButton>
      </Box>
    </Wrapper>
  );
}
